import { ActivityType, UpdateActivityType } from '@/entities/activityType';
import { ActivityTypeService } from '@/services/ActivityTypeService';
import { useEffect, useState} from 'react';

export function useActivityType(){
  const [activityTypes, setActivityTypes] = useState<ActivityType[]>([]);
  const [searchedActivityType, setSearchedActivityType] = useState<ActivityType[]>([]);
  const [errorActivityTypes ,setErrorActivityTypes] = useState(false);

  useEffect(()=>{
    const fetchActivityTypes = async () =>{
      try{
        const response = await ActivityTypeService.getActivityTypes();
        if(response){
          const activityTypes = response.map((data)=>({
            id: data.id,
            name: data.name
          })).sort((a, b) => a.id - b.id);
          setActivityTypes(activityTypes);
        }
      }catch(error){
        console.error(`Falha ao carregar Tipos de Atividade: ${error}`);
        setErrorActivityTypes(true);
      }
    };
    fetchActivityTypes();
  }, []);

  const saveActivityTypes = async (activityTypes: UpdateActivityType[]) =>{
    try{
      await ActivityTypeService.updateOrCreateActivityTypes(activityTypes);
    } catch(error){
      console.error(`Falha ao atualizar os dados: ${error}`);
    }
  };

  const deleteActivityType = async (id: number) => {
    try{
      await ActivityTypeService.deleteActivityTypes(id);
    }catch(error){
      console.error(`Falha ao deletar dados: ${error}`);
    }
  };

  const createActivityType = async (activityType: ActivityType)=>{
    try{
      await ActivityTypeService.createActivityTypes(activityType);
    }catch(error){
      console.error(`Falha ao criar novos dados: ${error}`);
    }

  };

  const searchActivityType = async (contains:string) => {
    try{
      const response = await ActivityTypeService.searchActivityTypes(contains);
      if(response){
        const activityTypes = response.map((data: any)=>({
          id: data.id,
          name: data.name
        }));
        setSearchedActivityType(activityTypes);
      }
    }catch(error){
      console.error(`Falha ao buscar dados: ${error}`);
    }
  };

  return {
    activityTypes,
    searchedActivityType,
    saveActivityTypes,
    deleteActivityType,
    createActivityType,
    searchActivityType
  };
}

